import { assignInlineVars } from '@vanilla-extract/dynamic';
import { Property } from 'csstype';
import React, { ComponentPropsWithoutRef, ReactNode } from 'react';

import { ComponentPropsWithoutStyles } from '@/util/ComponentPropsWithoutStyles';

import * as styles from './button.css';

export type ButtonProps = {
  leftIcon?: ReactNode;
  rightIcon?: ReactNode;
  variant?: keyof typeof styles.root;
  borderLeftRounded?: boolean;
  borderRightRounded?: boolean;
  minWidth?: Property.MinWidth;
  minHeight?: Property.MinHeight;
} & ComponentPropsWithoutStyles<ComponentPropsWithoutRef<'button'>>;

export const Button: React.FC<ButtonProps> = React.forwardRef<HTMLButtonElement, ButtonProps>(
  function Button(
    {
      children,
      leftIcon,
      rightIcon,
      variant = 'default',
      borderLeftRounded = true,
      borderRightRounded = true,
      minWidth,
      minHeight,
      ...props
    },
    ref,
  ) {
    return (
      <button
        className={styles.root[variant]}
        style={{
          ...assignInlineVars({
            [styles.minWidthVar]: minWidth || 'none',
            [styles.minHeightVar]: minHeight || 'none',
            [styles.borderLeftRadiusVar]: borderLeftRounded ? '6px' : '0',
            [styles.borderRightRadiusVar]: borderRightRounded ? '6px' : '0',
          }),
        }}
        ref={ref}
        {...props}
      >
        {leftIcon || rightIcon ? (
          <div className={styles.buttonInside}>
            {leftIcon && <span className={styles.iconContainer}>{leftIcon}</span>}
            {children}
            {rightIcon && <span className={styles.iconContainer}>{rightIcon}</span>}
          </div>
        ) : (
          <>{children}</>
        )}
      </button>
    );
  },
);
